import React from 'react';
import { Client } from '@ansvar-sakerhet/api-client';
import { CustomerInfoForm } from './components/CustomerInfoForm';

type Props = { client: Client };

export const CustomerInfo = ({ client }: Props) => {
  return <CustomerInfoForm client={client} />;
};
